import React from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { Redirect, Route } from 'react-router-dom';

const AuthProtected = (props) => {
    const isAuthenticated = useIsAuthenticated();
    /*
     *redirect is un-auth access protected routes via url
     */
    if (!isAuthenticated) {
        return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
    }
    return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                return <Component {...props} />;
            }}
        />
    );
};

export { AuthProtected, AccessRoute };
